import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { Nextstep, setQuesCountIndex, setQuesTopicName } from './features/counterSlice';
import { AnswerResult, NoanswerResult } from './features/resultSlice';
import { Snackbar, Alert } from '@mui/material';
// Load data from localStorage
let data = JSON.parse(localStorage.getItem('QuestionData'));

function ReadTest() {

    const apiData = useSelector((state) => state.questionResult.apiData);
    const [data, setdata] = useState(apiData.data);
    const TOTAL_LISTEN = apiData?.data?.Read_Que?.Total || 0;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');

    const [readQueData, setReadQueData] = useState([]);

    const [selectedOption, setSelectedOption] = useState(null);
    const pagestep = useSelector((state) => state.counter.value);
    const dispatch = useDispatch();


    // Check for no question data
    if (!data || !data.Read_Que || data.Read_Que.length === 0) {
        return (
            <Box sx={{ margin: 'auto', p: 2, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ color: 'red' }}>
                    No question found
                </Typography>
            </Box>
        );
    }

    const currentQuestion = data.Read_Que[currentIndex];
    const Qcategory = currentQuestion.category;
    const Answer = currentQuestion.Answer;
    const handleNext = () => {
        if (selectedOption == null) {
            setOpen(true);
            setMessage('Please enter your answer before proceeding!');
            return;
        }
        // ======================== local storage start ======================== 
        const formatData = {
            Quetion: currentQuestion?.Quetion || "",
            id: currentQuestion?.id,
            selectedOption: selectedOption?.trim() || "",
            answer: Answer,
        }
        const updatedData = [...readQueData, formatData];
        setReadQueData(updatedData);
        localStorage.setItem("Read_Que", JSON.stringify(updatedData));
        // ======================== local storage end ======================== 



        if (Answer === selectedOption) {
            dispatch(AnswerResult({ testIndex: 3 }));
        } else {
            dispatch(NoanswerResult({ testIndex: 3 }));
        }

        setSelectedOption(null);

        setCurrentIndex((prevIndex) => {
            const newIndex =
                prevIndex < TOTAL_LISTEN - 1 ? prevIndex + 1 : prevIndex;

            if (prevIndex === TOTAL_LISTEN - 1) {
                dispatch(Nextstep());
            }
            dispatch(setQuesCountIndex(newIndex));

            return newIndex;
        });
    };

    const handleSpeak = (audioFileName) => {
        const audio = new Audio(`${audioFileName}`);
        audio.play();
    };


    return (
        <Box sx={{ maxWidth: 800, margin: 'auto', marginBottom: 10, p: 2, textAlign: 'center' }}>
            {/* Header */}


            {/* Image Options */}
            {Qcategory === 'Image' && (
                <>
                    <Box sx={{ marginTop: 3 }}>
                        <Typography
                            variant="body1"
                            sx={{ fontSize: '1.1rem', marginBottom: 1, textAlign: 'left' }}
                        >
                            {currentQuestion.description}
                        </Typography>

                        <Box
                            display="flex"
                            alignItems="center"
                            sx={{ gap: 1, padding: 2, backgroundColor: '#fff', borderRadius: '10px', boxShadow: 3 }}
                        >
                            <Typography
                                variant="body1"
                                sx={{ fontWeight: 'bold', color: '#ff02bd' }}
                            >
                                Q {currentIndex + 1}.  {currentQuestion.Quetion}
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        sx={{ marginTop: 3, display: 'flex', flexWrap: 'wrap', gap: 3, justifyContent: 'center' }}
                    >
                        <RadioGroup
                            row
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.target.value)}
                            sx={{ width: '100%', justifyContent: 'space-around' }}
                        >
                            {currentQuestion.Options.map((option, index) => (
                                <FormControlLabel
                                    key={index}
                                    value={option.value}
                                    control={
                                        <Radio
                                            color="primary"
                                            sx={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                zIndex: 1,
                                            }}
                                        />
                                    }
                                    label={
                                        <Box sx={{ textAlign: 'center', maxWidth: '150px' }}>
                                            <img
                                                src={option.Image}
                                                alt={option.label}
                                                style={{ width: '100%' }}
                                            />
                                        </Box>
                                    }
                                    sx={{
                                        position: 'relative',
                                        display: 'inline-block',
                                    }}
                                />
                            ))}
                        </RadioGroup>
                    </Box>
                </>
            )}

            {/* Radio Options */}
            {Qcategory === 'Radio' && (
                <>

                    <Box sx={{ marginTop: 3 }}>
                        <Typography
                            variant="body1"
                            sx={{ fontSize: '1.1rem', marginBottom: 1, textAlign: 'left' }}
                        >
                            {currentQuestion.description}
                        </Typography>

                        <Box
                            display="flex"
                            alignItems="center"
                            sx={{ gap: 1, padding: 2, backgroundColor: '#fff', borderRadius: '10px', boxShadow: 3 }}
                        >
                            <Typography
                                variant="body1"
                                sx={{ fontWeight: 'bold', color: '#ff02bd' }}
                            >
                                {currentQuestion.Qustiondescription}
                            </Typography>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            marginTop: 2,
                            padding: 2,
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            borderRadius: '4px',
                            boxShadow: 3,
                        }}
                    >
                        <FormControl component="fieldset">
                            <FormLabel
                                component="legend"
                                sx={{ fontSize: '1.2rem', fontWeight: 'bold' }}
                            >
                                Q {currentIndex + 1}. {currentQuestion.Quetion}
                            </FormLabel>
                            <RadioGroup
                                aria-label={`question${currentIndex + 1}`}
                                name={`question${currentIndex + 1}`}
                                value={selectedOption}
                                onChange={(e) => setSelectedOption(e.target.value)}
                                sx={{ marginTop: 1 }}
                            >
                                {currentQuestion.Options.map((option, index) => (
                                    <FormControlLabel
                                        key={index}
                                        value={option.label}
                                        control={<Radio color="primary" />}
                                        label={option.label}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </>
            )}

            {/* Next Button */}
            <Box mt={3}>
                <Button onClick={handleNext} sx={{ padding: '10px 40px' }}>
                    <img
                        src="/images/Picture7.png"
                        alt="Next"
                        style={{ width: '150px', height: 'auto' }}
                    />
                </Button>
            </Box>
            <Snackbar
                open={open}
                autoHideDuration={5000}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpen(false)} severity="warning" sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </Box>
    );
}

export default ReadTest;
